/**
 * RiskTypeChip Component
 * Visual chip component for risk type classification
 *
 * @version 2025.1.0
 */
import React from 'react';
import { Chip } from '@mui/material';
import { RiskType } from '../../../types/occupationalRisk';

interface RiskTypeChipProps {
  type: RiskType;
  size?: 'small' | 'medium';
}

export const RiskTypeChip: React.FC<RiskTypeChipProps> = ({ type, size = 'small' }) => {
  const getColorByType = (riskType: RiskType): 'error' | 'warning' | 'info' | 'success' | 'default' => {
    switch (riskType) {
      case RiskType.PHYSICAL:
        return 'success';
      case RiskType.CHEMICAL:
        return 'error';
      case RiskType.BIOLOGICAL:
        return 'warning';
      case RiskType.ERGONOMIC:
        return 'info';
      case RiskType.ACCIDENT:
        return 'error';
      default:
        return 'default';
    }
  };

  return (
    <Chip
      label={type}
      size={size}
      color={getColorByType(type)}
      variant="outlined"
    />
  );
};

export default RiskTypeChip;
